import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/l6j4p5d5_WhatsApp%20Image%202026-03-29%20at%2021.00.36.jpeg",
      title: "Women Farmers with Traditional Seeds",
      category: "Agriculture",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/l6j4p5d5_WhatsApp%20Image%202026-03-29%20at%2021.00.36.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/gv720gz7_WhatsApp%20Image%202026-03-29%20at%2021.00.38.jpeg",
      title: "Community Workshop & Discussion",
      category: "Training",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/gv720gz7_WhatsApp%20Image%202026-03-29%20at%2021.00.38.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/11mq4nmv_WhatsApp%20Image%202026-03-29%20at%2021.00.39.jpeg",
      title: "Farmer Recognition Ceremony",
      category: "Events",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/11mq4nmv_WhatsApp%20Image%202026-03-29%20at%2021.00.39.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/tmx6tngi_WhatsApp%20Image%202026-03-29%20at%2021.00.40.jpeg",
      title: "Chamba Beej Utsav - Seed Exhibition",
      category: "Events",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/tmx6tngi_WhatsApp%20Image%202026-03-29%20at%2021.00.40.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/qwxjzi03_WhatsApp%20Image%202026-03-29%20at%2021.00.42.jpeg",
      title: "PAHAD Organics Product Exhibition",
      category: "PAHAD Organics",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/qwxjzi03_WhatsApp%20Image%202026-03-29%20at%2021.00.42.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/1tmfe0jd_WhatsApp%20Image%202026-03-29%20at%2008.52.39.jpeg",
      title: "Community Training Workshop",
      category: "Training",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/1tmfe0jd_WhatsApp%20Image%202026-03-29%20at%2008.52.39.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/ujqt3uk1_WhatsApp%20Image%202026-03-29%20at%2008.53.47.jpeg",
      title: "Partnership with Krishi Vigyan Kendra",
      category: "Collaboration",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/ujqt3uk1_WhatsApp%20Image%202026-03-29%20at%2008.53.47.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/vs2uh2wk_WhatsApp%20Image%202026-03-29%20at%2008.53.50.jpeg",
      title: "PAHAD Organics Exhibition Stall",
      category: "PAHAD Organics",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/vs2uh2wk_WhatsApp%20Image%202026-03-29%20at%2008.53.50.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/aitjvr0r_WhatsApp%20Image%202026-03-29%20at%2008.53.51%20%284%29.jpeg",
      title: "Flood Relief Distribution 2025",
      category: "Disaster Relief",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/aitjvr0r_WhatsApp%20Image%202026-03-29%20at%2008.53.51%20%284%29.jpeg",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/viy5koac_WhatsApp%20Image%202026-03-29%20at%2008.54.00.jpeg",
      title: "Organic Products Display",
      category: "PAHAD Organics",
      thumbnail: "https://customer-assets.emergentagent.com/job_pahad-organics/artifacts/viy5koac_WhatsApp%20Image%202026-03-29%20at%2008.54.00.jpeg",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1701153758624-4b3d352bcfbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjYWxtJTIwaGltYWxheWFzJTIwbW91bnRhaW4lMjBsYW5kc2NhcGUlMjBkaGFyYW1zaGFsYXxlbnwwfHx8fDE3NzQ3NjM2OTd8MA&ixlib=rb-4.1.0&q=85')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/50" />
        </div>
        <div className="relative z-10 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl sm:text-5xl lg:text-6xl font-heading font-semibold text-white"
            style={{ textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}
          >
            Gallery
          </motion.h1>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-24 bg-[#F9F8F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6">
            {galleryImages.map((image, index) => {
              const colSpan = index % 5 === 0 ? "md:col-span-4 lg:col-span-6" : index % 3 === 0 ? "md:col-span-5 lg:col-span-4" : "md:col-span-3 lg:col-span-4";
              
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  data-testid={`gallery-image-${index}`}
                  className={`${colSpan} group cursor-pointer`}
                  onClick={() => setSelectedImage(image)}
                >
                  <div className="relative aspect-video overflow-hidden rounded-xl shadow-sm border border-[#E4E2DC]/40">
                    <img
                      src={image.thumbnail}
                      alt={image.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-4">
                        <p className="text-white font-medium">{image.title}</p>
                        <p className="text-white/80 text-sm">{image.category}</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            data-testid="gallery-modal"
          >
            <button
              onClick={() => setSelectedImage(null)}
              data-testid="gallery-modal-close"
              className="absolute top-4 right-4 text-white hover:text-[#8C9A74] transition-colors"
            >
              <X className="h-8 w-8" />
            </button>
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
              className="max-w-4xl w-full"
            >
              <img
                src={selectedImage.url.includes('.pdf') ? selectedImage.thumbnail : selectedImage.url}
                alt={selectedImage.title}
                className="w-full h-auto rounded-lg"
              />
              <div className="mt-4 text-center">
                <h3 className="text-white text-xl font-heading font-medium">{selectedImage.title}</h3>
                <p className="text-white/70 text-sm mt-1">{selectedImage.category}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
